import { AdvertiserBean, AdvertiserControllerApi, ItemResponseAdvertiserBeanObject, ListResponseAdvertiserBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class AdvertiserApi extends BaseApi {
    api: AdvertiserControllerApi

    constructor() {
        super()
        this.api = new AdvertiserControllerApi(configuration, configuration.basePath, this.fetch)
    }

    async list(size: number = 20, page: number = 1, sort, search, mediaAgency, active): Promise<ListResponseAdvertiserBean> {
        return this.call(() => this.api.advertiserList(search, mediaAgency, active, { query: { size, page, sort } }))
    }

    async all(): Promise<ListResponseAdvertiserBean> {
        return this.call(() => this.api.advertiserList())
    }

    async create(advertiser: AdvertiserBean): Promise<ItemResponseAdvertiserBeanObject> {
        return this.call(() => this.api.createAdvertiser(advertiser))
    }

    async edit(id: any, advertiser: AdvertiserBean): Promise<ItemResponseAdvertiserBeanObject> {
        return this.call(() => this.api.editAdvertiser(advertiser, id))
    }

    async view(id: any): Promise<ItemResponseAdvertiserBeanObject> {
        return this.call(() => this.api.advertiser(id))
    }

    async delete(id: any): Promise<void> {
        return this.call(() => this.api.deleteAdvertiser(id))
    }

    async activate(id: any): Promise<void> {
        return this.call(() => this.api.activateAdvertiser(id))
    }
}

const advertiserApi = new AdvertiserApi()
export default advertiserApi


// WEBPACK FOOTER //
// ./src/component/app/advertiser/AdvertiserApi.ts